import axios from 'axios';

export const SERVICE_URL_BASE = process.env.GATSBY_BASE_URL_API;
export const SERVICE_URL_ESTIMADOR = '/ux/estimator-pension/v1/estimator/pension/fastpensionestimator';
const SUBSCRIPTION_KEY_ESTIMADOR = process.env.GATSBY_ESTIMATOR_PENSION_API_SK;

export default axios.create({
  baseURL: SERVICE_URL_BASE,
  responseType: 'json',
});

export const CONFIG = {
  headers: {
    'Ocp-Apim-Subscription-Key': SUBSCRIPTION_KEY_ESTIMADOR
  }
};
